import { render } from "./QualityEventsTable.vue?vue&type=template&id=36c9e94f&scoped=true"
import script from "./QualityEventsTable.vue?vue&type=script&lang=js"
export * from "./QualityEventsTable.vue?vue&type=script&lang=js"

import "./QualityEventsTable.vue?vue&type=style&index=0&id=36c9e94f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c9e94f"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBar,QSpace,QBtn,QTooltip,QCardSection,QTable,QTd,QChip,QIcon});
